<template>
  <div id="app">
    <div v-if="this.$route.path == '/login'">
      <router-view />
    </div>
    <div v-else>
      <div id="app__header">
        <div>
          <h4>PSPP Wisuda</h4>
          <select class="kampus" id="session-kampus" v-if="$user.access == 'ADMIN'" v-model="idKampus"
            @change="summarize()">
            <option value="-1">Semua Kampus</option>
            <option value="1">Lampung</option>
            <option value="2">Jakarta</option>
            <option value="3">Yogyakarta</option>
            <option value="5">Makassar</option>
            <option value="6">Bali</option>
          </select>

          <select class="kampus angkatan" id="angkatan" v-model="angkatan" @change="summarize()">
            <option v-for="item, index in historyAngkatan" :value="item">{{ item }}</option>
          </select>
        </div>
        <span @click="logout"> {{ this.$user.nama }} | Logout
          <logout />
        </span>
      </div>
      <div id="app__sidebar">
        <ul>
          <li>
            <router-link to="/daftar/all" :class="{ active: $route.params.status == 'all' }">
              Semua <span>{{ summary.all }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/pending" :class="{ active: $route.params.status == 'pending' }">
              Belum Divalidasi <span>{{ summary.pending }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/deposit" :class="{ active: $route.params.status == 'deposit' }">
              Sudah Deposit <span>{{ summary.deposit }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/validasi" :class="{ active: $route.params.status == 'validasi' }">
              Sudah Divalidasi <span>{{ summary.validasi }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/reject" :class="{ active: $route.params.status == 'reject' }">
              Ditolak <span>{{ summary.reject }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/toga_deposit" :class="{ active: $route.params.status == 'toga_deposit' }">
              Toga & Deposit <span>{{ summary.togaDeposit }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/checkin" :class="{ active: $route.params.status == 'checkin' }">
              Sudah Checkin <span>{{ summary.checkin }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/daftar/sertifikat" :class="{ active: $route.params.status == 'sertifikat' }">
              Sertifikat <span>{{ summary.sertifikat }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div id="app__content">
        <router-view :angkatan="angkatan" :id_kampus="idKampus" />
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "./components/icons/Logout.vue";
import * as api from "./api/Api";

export default {
  name: "App",
  components: {
    Logout,
  },
  data() {
    return {
      summary: {
        all: 0,
        pending: 0,
        deposit: 0,
        validasi: 0,
        reject: 0,
        togaDeposit: 0,
        checkin: 0,
        sertifikat: 0,
      },
      filter: {
        id_kampus: -1,
      },
      idKampus: "-1",
      angkatan: "",

      historyAngkatan: [],
    };
  },
  methods: {
    summarize() {
      let param = "";
      if (this.$user.access != "ADMIN") {
        param += "id_kampus=" + this.$user.id_kampus;
      }
      if (this.idKampus != -1) {
        param += "id_kampus=" + this.idKampus;
      }
      if (this.angkatan != "ALL") {
        param += "&angkatan=" + encodeURIComponent(this.angkatan);
      }

      api.get("/v1/wisuda/PendaftaranController/summary?" + param).then((r) => {
        if (r.valid) {
          this.summary.all = r.data.ALL;
          this.summary.pending = r.data.PENDING;
          this.summary.deposit = r.data.DEPOSIT;
          this.summary.validasi = r.data.VALIDASI;
          this.summary.reject = r.data.REJECT;
          this.summary.togaDeposit = r.data.TOGA_DEPOSIT;
          this.summary.checkin = r.data.CHECKIN;
          this.summary.sertifikat = r.data.SERTIFIKAT;
        }
      });

      localStorage.setItem("id_kampus", this.idKampus);
      localStorage.setItem("angkatan", this.angkatan);
    },
    loadHistoryAngkatan() {
      api.get("/v1/wisuda/PendaftaranController/getHistoryAngkatanWisuda").then((r) => {
        this.historyAngkatan = r.data;
      });
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
  },
  mounted() {
    if (localStorage.getItem("id_kampus")) {
      if (localStorage.getItem("id_kampus") != -1) {
        this.idKampus = localStorage.getItem("id_kampus");
      }
    }
    if (localStorage.getItem("angkatan")) {
      this.angkatan = localStorage.getItem("angkatan");
    }
    this.summarize();
    this.loadHistoryAngkatan();

    if (this.$route.path != "/login") {
      if (!this.$store.state.settings.user.id) {
        this.$router.push("/login");
      }
    }

    if (this.$route.path == "/") {
      this.$router.push("/daftar/all");
    }
  },
  watch: {
    $route(to) {
      this.summarize();
      if (to.path == "/") {
        this.$router.push("/daftar/all");
      }
    },
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  background: #f5f7f9;
}

* {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI",
    "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  &__header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #344955;
    color: #fff;
    z-index: 1;
    line-height: 60px;
    display: flex;
    justify-content: space-between;

    h4 {
      margin: 0;
      padding-left: 15px;
    }

    .kampus {
      position: absolute;
      top: 10px;
      left: 220px;
      width: 200px;

      &.angkatan {
        left: calc(220px + 200px + 15px);
      }
    }

    span {
      font-size: 14px;
      display: flex;
      margin-right: 15px;
      cursor: pointer;

      .icon {
        width: 20px;
        margin-left: 5px;
      }
    }
  }

  &__sidebar {
    position: fixed;
    top: 60px;
    left: 0px;
    width: 200px;
    height: calc(100% - 60px);
    background: #eaecee;
    border-right: 1px solid #ddd;
    color: #fff;
    overflow-y: auto;

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      font-size: 14px;

      li {
        a {
          color: #333;
          padding: 10px 15px;
          display: block;
          text-decoration: none;
          -webkit-transition: color 0.2s linear;
          -moz-transition: color 0.2s linear;
          transition: color 0.2s linear;

          &.active {
            background: #d0d7dd;
          }

          &:hover {
            background: #d0d7dd;
          }

          span {
            background: #6c757d;
            color: #fff;
            padding: 0.25em 0.4em;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            vertical-align: baseline;
            border-radius: 0.25rem;
            float: right;
          }
        }
      }
    }
  }

  &__content {
    position: fixed;
    top: 60px;
    left: 210px;
    width: calc(100% - 220px);
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}

input,
select,
textarea {
  border: 1px solid #ccc;
  padding: 10px;
  width: calc(100% - 22px);
  border-radius: 4px;
  outline: none;

  &:focus {
    border: 1px solid #0839bc;
  }
}

select {
  width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

button {
  background: #007bff;
  border: 0;
  border-radius: 0.3rem;
  color: #fff;
  padding: 0.4rem 1.2rem;
  text-decoration: none;
  text-align: center;
  user-select: none;
  padding: 4px 10px;
  cursor: pointer;
  transition: ease 0.2s all;

  &:hover {
    background: #0069d9;
  }

  &:active {
    background: #0056b1;
  }

  .icon {
    margin-top: 4px;
    margin-left: 10px;
  }
}

.toast {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
  bottom: 50%;
  left: 15px;
  border-radius: 6px;

  p {
    color: #fff;
    margin: 0;
    padding: 20px 15px;
    text-align: center;
  }
}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.animate-flicker {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}
</style>



// WEBPACK FOOTER //
// src/App.vue